// extracted by mini-css-extract-plugin
export default {"termsModalContent":"TermsModal_termsModalContent__2u6GJ","termsModalButton":"TermsModal_termsModalButton__g8UV7"};